import React, { useState, useEffect } from 'react';
import Cards from '../../components/cards';
import Header from '../../components/header';
import Nav from '../../components/nav';
import Footer from '../../components/footer';
import "./styles_index.css";
import "./reset.css";
// import "./dark.css";


function Inicio() {
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <div className='App'>
      <div className='fondoImg'></div>
      <div className='fondo'></div>
      <div className='fondo2'></div>
      <div className='fondo3'></div>
      <Nav toggleTheme={toggleTheme} />
      <Header/>
      {/* <Cards/> */}
      <Footer/>
      {/* <Header/> */}
    </div>
  );
}

export default Inicio;
